import { Modal } from "react-bootstrap";
import Messages from "../../../common/ui/Messages";

export default function MethodChangeModal(props) {
    return (
        <Modal show={props.pickupOrDelivery.MethodChangeModal.ModalIsShown} backdrop="static" keyboard={false}>
            <Modal.Body>
                <div className="row col-12 justify-content-center">
                    <div className="col-10 text-center">
                        {Messages.MethodWarnChange}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="col-12 d-flex justify-content-sm-between justify-content-center flex-column flex-sm-row">
                    <button type="button" className="btn btn-outline-dark rounded-pill px-5 my-1 my-sm-0 mx-auto" onClick={props.handleCloseMethodChangeModal}>Cancel change</button>
                    <button type="button" className="btn btn-dark rounded-pill px-5 my-1 my-sm-0 mx-auto" onClick={props.handleConfirmMethodChange}>Start order again</button>                    
                </div>
            </Modal.Footer>
        </Modal>
    )
}